import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { ReferToneRequestImpl } from '../../../../core/api/tune/refertone/refertonerequest';
import { ReferToneResponse } from '../../../../core/api/tune/refertone/refertoneresponse';
import { ReferToneDto, ReferToneDtoImpl } from '../../../../core/dto/refertone/refertonedto';
import { GetTonePriceRequestImpl } from 'src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepricerequest';
import { GetTonePriceResponse } from 'src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepriceresponse';
import { GetTonePriceDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedto';


export interface TellAFriendAPIModel extends APIModel 
{
    getTonePrice(toneDto: ReferToneDto): void;
}

export class TellAFriendAPIModelImpl extends APIModelImpl implements TellAFriendAPIModel 
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) {
        super(applicationContext, apiModelHandler);

    }

    getTonePrice(toneDto: ReferToneDto): void 
    {

        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());

        let msisdnList = 
        '{"bPartyMsisdn":"' +  toneDto.getMsisdnList()[0]+ '"}';
        //  '{"bPartyMsisdn":"' + toneDto.getMsisdnList()[1] +'"},'+
        //  '{"bPartyMsisdn":"' + toneDto.getMsisdnList()[2] + '"}';
         
        getTonePriceDto.setBPartyMsisdnList("[" + msisdnList + "]");
        getTonePriceDto.setToneId(toneDto.getToneId());
        getTonePriceDto.setValidationIdentifier("2");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.getAPIProcesssorFactory().getToneProcessorFactory().getGetTonePriceAPIProcessor()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            // this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            // getTonePriceResponse.getDescription(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
            // console.log("gift *******",JSON.stringify(getTonePriceResponse.getGetTonePriceDto()));
            (toneDto as ReferToneDtoImpl).setPackName(getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0].getPackName());
            this.tellAFriend(toneDto);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }

    tellAFriend(tellAFriendDto: ReferToneDto): void 
    {
        (tellAFriendDto as ReferToneDtoImpl).setLanguage(this.getContext().getUserContext().getLanguage());
        
        this.getAPIProcesssorFactory().getToneProcessorFactory().getReferToneDetails()
        .success((buyResponse : ReferToneResponse)=>
         {
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : ReferToneResponse)=>
       {
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new ReferToneRequestImpl(tellAFriendDto));
    }
}





// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/tellafriend/tellafriendapimodel.tsx